import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const CalendarIcon = (props) => {
  return (
    <SvgIcon
      className="text-gray-400"
      width="20" height="20" viewBox="0 0 20 20"
      {...props}>
      <path d="M440,199v-4m8,4v-4m-9,8h10m-12,10h14a2,2,0,0,0,2-2V199a2,2,0,0,0-2-2H437a2,2,0,0,0-2,2v12A2,2,0,0,0,437,213Z" transform="translate(-434 -194)" fill="none" stroke="#9fa6b2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    </SvgIcon>
  );
};

CalendarIcon.propTypes = {}

CalendarIcon.defaultProps = {}

export default CalendarIcon;